import { withStyles } from 'tss-react/mui';
import { Theme247 } from "./Theme247";
// TODO jss-to-tss-react codemod: '@global' is not supported by tss-react.
// See https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override for alternatives.
export const GlobalCss = withStyles(() => null, {
  '@global': {
    ':root': {
      '--color-primary': '#0E3F51',
      '--color-primary-rgb': '14, 63, 81',
      '--color-secondary': '#38748D',
      '--color-secondary-rgb': '56, 116, 141',
      '--Primary-800': '#0E3F51',
      '--Secondary-500': '#38748D',
      "--tab": "#0E3F51"
    },
    ':root[data-account-mode="fette"]': {
      '--color-primary': 'var(--color-primary)',
      '--color-primary-rgb': '0, 156, 180',
      '--color-secondary': '#3C4559',
      '--color-secondary-rgb': '60, 69, 89',
      '--Primary-800': 'var(--color-primary)',
      '--Secondary-500': '#3C4559',
      "--tab": "#000000"
   },
    'p a[href]': {
      color: 'var(--color-secondary)',
    },
  },
});
